import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { environment } from '../../environments/environment';
import { ActiveVehicleState } from './active-vehicle';
import { ApplicationState } from './application';
import { CostCentreState } from './cost-centre';
import { ExceptionState} from './exception';
import { FeatureState } from './feature';
import { LogState } from './log';
import { PoiState } from './poi';
import { UserState } from './user';
import { VehicleState } from './vehicle';
import { VehicleIconState } from './vehicle-icon';
import { VehicleInfoState } from './vehicle-info';

@NgModule({
  imports: [
    NgxsModule.forRoot(
      [
        ApplicationState,
        LogState,
        VehicleState,
        UserState,
        PoiState,
        ExceptionState,
        ActiveVehicleState,
        VehicleInfoState,
        CostCentreState,
        VehicleIconState,
        FeatureState,
      ],
      { developmentMode: !environment.production },
    ),
    NgxsLoggerPluginModule.forRoot({
      collapsed: true,
      disabled: environment.production,
    }),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production,
    }),
  ],
  declarations: [],
  providers: [],
})
export class NgxsStoreModule {}
